import type { DataRequestStatus } from '@api-client/api'
import { useTranslation } from 'react-i18next'

import { type PillVariant, StatusPillContainer } from './styles'

interface Props {
	isCustomer: boolean
	status: DataRequestStatus
}

const CUSTOMER_STATUS_VARIANT = {
	NOT_STARTED: 'info',
	REQUESTED: 'primary',
	REQUESTED_CLARIFICATION: 'primary',
	PENDING_REVIEW: 'reversed',
	COMPLETED: 'success',
	REJECTED: 'warning',
	DECLINED: 'error',
	CANCELED: 'warning',
} as const satisfies Record<Props['status'], PillVariant>
const SUPPLIER_STATUS_VARIANT = {
	NOT_STARTED: 'reversed',
	REQUESTED: 'info',
	REQUESTED_CLARIFICATION: 'info',
	PENDING_REVIEW: 'primary',
	COMPLETED: 'success',
	REJECTED: 'error',
	DECLINED: 'warning',
	CANCELED: 'warning',
} as const satisfies Record<Props['status'], PillVariant>

const ProductStatusPill: React.FC<Props> = ({ isCustomer, status }) => {
	const { t } = useTranslation()
	const label = isCustomer
		? t('request.asCustomer.status', { context: status })
		: t('request.asSupplier.status', { context: status })
	const variant = isCustomer
		? CUSTOMER_STATUS_VARIANT[status]
		: SUPPLIER_STATUS_VARIANT[status]
	return <StatusPillContainer className={variant}>{label}</StatusPillContainer>
}

export { ProductStatusPill }
